import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { CookieService } from 'ngx-cookie-service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

declare var $:any;
@Component({
	selector: 'app-user-survey-posted-question',
	templateUrl: './user-survey-posted-question.component.html',
	styleUrls: ['./user-survey-posted-question.component.css']
})
export class UserSurveyPostedQusestionComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	userName: any;
	email: any;
	phone: any;
	surveyList: any;
	selectedUserId :any;
	profileImage:any;
	prevUrl:any;
	is_from_group=false;
	is_group_survey_report = false;
    route :any;
	constructor(private validationService: ValidationService, private authService: AuthService, private commonService: CommonService,
		private cookieService: CookieService, private router: Router, private pagerService: PagerService, private activatedRoute: ActivatedRoute) {
		
		}

	ngOnInit() {
		this.commonService.process();
	
		this.activatedRoute.params.subscribe((params: any) => {
		
			if (params.user_id) {
			
				this.selectedUserId = params.user_id;
			//	this.prevUrl = params.prev_token;
				//this.is_from_group = params.prev_token.indexOf('groupList') >-1 ? true : false;
				this.pager = 1;
				this.limit = 10;
			
				this.getSelectedUserSurvey(this.pager,this.limit,this.selectedUserId);
			}
		});
	
	
	}
	 
	// Get selected user survey
	getSelectedUserSurvey = function (pageNo, limit, userId) {
		this.commonService.process();
		
		this.authService.getSelectedUserSurvey(pageNo, limit, userId).subscribe(data => {
			if (data.success) {
				this.surveyList = data.survey;
				this.total = data.total;
				this.profileImage = this.commonService.imageUrl + this.surveyList[0].user_id.profile_pic;
				this.userName = this.surveyList[0].user_id.name;
				$(".navbar-brand").html(this.userName + '\'s Profile');
				this.email = this.surveyList[0].user_id.email;
				this.phone = this.surveyList[0].user_id.phone;
				this.setPage(pageNo, true);
			}
			else{
				this.authService.getUserProfile(userId).subscribe(data => {
					if (data.success) {
						this.profileImage = this.commonService.imageUrl + data.user.profile_pic;
						this.userName = data.user.name;
						$(".navbar-brand").html(this.userName + '\'s Profile');
						this.email = data.user.email;
						this.phone = data.user.phone;
					}
				});
			}
			this.commonService.hideProcess();
		});
	}
	// Delete selected Survey Details
	deleteSelectedSurvey = function (survey) {
		
		this.isDeleteSurvey = true;
		this.deleteSelectedSurveyData = survey
	}

	// Delete Survey
	deleteSurvey = function (_id) {
		this.authService.deleteSurvey(_id).subscribe(data => {
		
			if (data.success) {
				this.authService.cancelProcess();
				this.getSelectedUserSurvey(this.pager,this.limit,this.selectedUserId);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}
	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getSelectedUserSurvey(page, this.limit, this.selectedUserId);
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/user-survey-posted-question/user-survey-posted-question.component.ts